export const StaffCategories: any = {
    internal_staff: { id: "Internal", name: "Internal Staff", db: "Internal" },
    intelypro: { id: "IntelyPro", name: "IntelyPros", db: "IntelyPro" },
    agency_staff: { id: "OutsideStaff", name: "Outside Staff", db: "OutsideStaff" }
};
